import { CITY_ID } from './categories';

/**
 * A jogi dokumentumok hivatkozásai egy helyen.
 *
 * A dokumentumok PDF-ként élnek a `public/doc/` alatt. A Google Play elutasította
 * az appot, mert az adatvédelmi tájékoztató URL-je PDF-re mutatott
 * ("web page content type is application/pdf"), ezért az átalakított
 * dokumentumok markdownból generált, önálló HTML oldalként is elérhetők
 * (`content/legal/*.md` -> `public/doc/*.html`, lásd
 * `scripts/build-legal-pages.js`).
 *
 * A régi PDF-ek szándékosan maradnak élesben: a boltokban lévő app-verziók még
 * azokra hivatkoznak, és azokat nem lehet visszamenőleg frissíteni.
 */

/** Amelyik dokumentumnak már van HTML változata. Egy új átalakítás = egy sor. */
export const LEGAL_HTML = new Set(['adatkezeles-forno']);

/** A dokumentum publikus hivatkozása — HTML, ha van belőle, különben PDF. */
export function legalHref(name: string): string {
  return LEGAL_HTML.has(name) ? `/doc/${name}.html` : `/doc/${name}.pdf`;
}

/**
 * A városhoz tartozó üzemeltető cég. Két külön jogi személy van, ezért a
 * dokumentumok is márkánként külön fájlok.
 */
export function companyForCity(city?: string): string {
  return city === CITY_ID[0].name ? 'forno' : 'pastaline';
}
